export default __webpack_public_path__ + "static/media/tickIcon.be6fb293.svg";